<template>
  <div
    v-if="!zcciEvents.length && !partnersEvents.length"
    class="p-3 text-center"
  >
    <h4>Заходів за даний період не знайдено</h4>
  </div>
  <div class="row position-relative">
    <div class="col-12 col-md-6">
      <event-card
        v-for="(event, index) in zcciEvents"
        :key="index"
        :event="event"
        owner="zcci"
      />
    </div>
    <div class="col-12 col-md-6">
      <event-card
        v-for="(event, index) in partnersEvents"
        :key="index"
        :event="event"
        owner="zcci-partners"
      />
    </div>
    <div
      v-if="fetching"
      class=" loader-wrapper position-absolute p-3 d-flex align-items-center justify-content-center "
    >
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import EventCard from './EventCard.vue';

export default {
  components: { EventCard },
  computed: {
    ...mapGetters({
      zcciEvents: 'eventCalendar/getCurrentZcciEvents',
      partnersEvents: 'eventCalendar/getCurrentPartnersEvents',
    }),
    ...mapState({
      fetching: state => state.eventCalendar.fetching,
    }),
  },
};
</script>

<style lang="scss">
.loader-wrapper {
  background-color: rgba(255, 255, 255, 0.5);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
</style>
